
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4659 9.26809L22.23 3.77879L21.4053 3.21326L18.3122 7.72396L16.1662 5.63752L15.4691 6.35452L18.4659 9.26809ZM4 4H12.7478C12.4269 4.76959 12.2496 5.6141 12.2496 6.5C12.2496 7.01627 12.3098 7.51848 12.4236 8H4C3.44772 8 3 8.44771 3 9V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V12.5999C21.3483 12.4713 21.6827 12.3138 22 12.1302V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowOpenpopupFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
